module.exports = __webpack_public_path__ + "static/media/sore-throat-white.7fd28298.svg";